/** @jsx jsx */
import { gql } from '@apollo/client';
import { jsx } from 'theme-ui';
import { graphql } from 'gatsby';
import { Title } from '@bottlebooks/gatsby-design-system';

export default function BrandName({ brand, ...rest }) {
  if (!brand) return null;
  return (
    <Title {...rest}>
      {brand.prefix && <span>{brand.prefix} </span>}
      {brand.nameWithoutPrefixAndSuffix}
      {brand.suffix && <span> {brand.suffix}</span>}
    </Title>
  );
}

export const fragment = graphql`
  fragment BrandName on AbstractBrand {
    prefix
    nameWithoutPrefixAndSuffix: name(removePrefix: true, removeSuffix: true)
    suffix
  }
`;

export const BrandNameFragment = gql`
  fragment BrandName on AbstractBrand {
    prefix
    nameWithoutPrefixAndSuffix: name(removePrefix: true, removeSuffix: true)
    suffix
  }
`;
